"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const referralPersonalCodeInputs = [
  {
    name: "variant",
    type: "string",
    defaultValue: "default",
    enum: [
      { label: "Default", value: "default" },
      { label: "Dashboard", value: "dashboard" },
      { label: "With background image", value: "withBackgroundImage" },
    ],
  },
  {
    name: "header",
    type: "string",
    friendlyName: "Header above code title",
    showIf: 'options.get("variant") === "withBackgroundImage"',
  },
  {
    name: "smallText",
    type: "string",
    showIf: 'options.get("variant") === "withBackgroundImage"',
    friendlyName: "Small bottom text",
  },
  {
    name: "backgroundImage",
    type: "file",
    showIf: 'options.get("variant") === "withBackgroundImage"',
    allowedFileTypes: IMAGE_FILE_TYPES,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fef3c4bcad86e40788fe504759413070b",
  },
  {
    name: "backgroundImageTablet",
    type: "file",
    showIf: 'options.get("variant") === "withBackgroundImage"',
    allowedFileTypes: IMAGE_FILE_TYPES,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fef3c4bcad86e40788fe504759413070b",
  },
  {
    name: "backgroundImageMobile",
    type: "file",
    showIf: 'options.get("variant") === "withBackgroundImage"',
    allowedFileTypes: IMAGE_FILE_TYPES,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fef3c4bcad86e40788fe504759413070b",
  },
  {
    name: "referralPageVariant",
    friendlyName: "Refer a friend page variant",
    type: "boolean",
    defaultValue: false,
    showIf: 'options.get("variant") === "withBackgroundImage"',
  },
  {
    name: "topHeader",
    friendlyName: "Top header",
    type: "string",
  },
  {
    name: "codeTitle",
    type: "string",
    defaultValue: "Your personal code",
    required: true,
  },
  {
    name: "shareTitle",
    defaultValue: "Share your code",
    type: "string",
    required: true,
  },
  {
    name: "description",
    type: "richText",
  },

  {
    name: "items",
    type: "list",
    defaultValue: [
      {
        img: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fef1ae9af4604416fb7ee36a299883fb5",
        url: "#",
        trackingName: "Telegram",
      },
      {
        img: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fa9ff7d81326a40cba59334078ce44085",
        url: "#",
        trackingName: "Instagram",
      },
      {
        img: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F8b96c3549e6c4cb587d485165e6da3bf",
        url: "#",
        trackingName: "WhatsApp",
      },
      {
        img: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F2663558f64a348a9ac8d5b290d5aa95c",
        url: "mailto:?body=share",
        trackingName: "Mail",
      },
    ],
    subFields: [
      {
        name: "url",
        type: "url",
        friendlyName: "Icon's URL",
        required: true,
      },
      {
        name: "img",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        required: true,
      },
      {
        name: "trackingName",
        type: "string",
        friendlyName: "Tracking name",
        required: true,
      },
    ],
    required: true,
  },
  {
    name: "infoTitle",
    friendlyName: "Info title",
    defaultValue: "Tap to copy to clipboard",
    type: "string",
  },
  {
    name: "registerUrl",
    type: "url",
    friendlyName: "Sign up button url",
    defaultValue: "#",
    required: false,
  },
  {
    name: "registerTitle",
    type: "string",
    defaultValue: "Sign up",
    friendlyName: "Sign up button label",
    required: false,
  },
  {
    name: "signInUrl",
    type: "url",
    defaultValue: "#",
    friendlyName: "Sign in button url",
    required: false,
  },
  {
    name: "signInTitle",
    type: "string",
    defaultValue: "Sign in",
    friendlyName: "Sign in button label",
    required: false,
  },
  {
    name: "withBottomCta",
    type: "boolean",
    required: false,
  },
  {
    name: "bottomCtaLabel",
    type: "string",
    required: false,
  },
  {
    name: "bottomCtaLink",
    type: "string",
    required: false,
  },
] as const satisfies Inputs;

export const ReferralPersonalCodeComponent: RegisteredComponent = {
  name: "ReferralPersonalCode",
  component: dynamic(async () =>
    withValidation(
      referralPersonalCodeInputs,
      (await import("./ReferralPersonalCode")).ReferralPersonalCode,
      "ReferralPersonalCode"
    )
  ),
  inputs: referralPersonalCodeInputs,
};
